import { Equipment } from './../index';

export class EquipmentForModelAndPoweredBy {
    public ModelId: number;
    public PoweredById: number;
    public Equipment: Equipment[] = [];
}
